import * as React from "react";
import type { SVGProps } from "react";
const SvgList = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 20 20"
    {...props}
  >
    <path
      stroke="#323232"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="M17.003 19.004H4.998a2 2 0 0 1-2.001-2.001V2.997a2 2 0 0 1 2-2h12.006a2 2 0 0 1 2 2v14.006a2 2 0 0 1-2 2"
      clipRule="evenodd"
    />
    <path
      stroke="#323232"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="M7.999 5.998h7.003M7.999 14.002h1M15.613 13.53l-1.946 1.945-1.166-1.167M7.999 10h7.003M1.496 5.998h3.001M1.496 14.002h2.802M1.496 10h2.802"
    />
  </svg>
);
export default SvgList;
